import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punecabbooking() {



  const cardData = {
"keyword": "Pune Cab Booking",

"headingDescription":
  "Shivai Travels provides easy and reliable Pune Cab Booking services for local travel, airport transfers, outstation journeys, business trips, family outings, and daily transportation needs. With affordable pricing, professional drivers, well-maintained vehicles, and timely pickups, we ensure a smooth and comfortable travel experience for every customer. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for individuals, families, tourists, and corporate travelers. Whether you need a one-way ride, round-trip booking, airport taxi, or full-day cab rental, Shivai Travels offers flexible travel solutions with transparent fares, simple online booking, and 24/7 customer support.",

"topPlaces": [
  {
    "title": "Instant Pune Cab Booking Online",
    "description": "Pune Cab Booking service allows users to book taxis instantly through online or mobile platforms. Quick confirmation, transparent pricing, and reliable drivers make travel easy and efficient."
  },
  {
    "title": "24/7 Pune Cab Availability",
    "description": "Round-the-clock Pune cab booking service ensures rides are available anytime, whether early morning airport trips or late-night emergency travel across the city."
  },
  {
    "title": "Affordable Cab Booking in Pune",
    "description": "Budget-friendly Pune cab booking options are available for daily commuters, students, and families looking for economical yet comfortable travel solutions."
  },
  {
    "title": "One-Way Cab Booking from Pune",
    "description": "One-way Pune cab booking is ideal for travelers heading to nearby cities without return plans, offering flexible pickup and cost-effective travel options."
  },
  {
    "title": "Outstation Cab Booking from Pune",
    "description": "Outstation cab booking from Pune covers popular destinations like Mumbai, Shirdi, Goa, Nashik, and Mahabaleshwar with safe long-distance travel and experienced drivers."
  },
  {
    "title": "Airport Cab Booking Pune",
    "description": "Pune airport cab booking ensures timely pickup and drop services for stress-free domestic and international airport transfers with professional drivers."
  },
  {
    "title": "Corporate Cab Booking Pune",
    "description": "Corporate cab booking in Pune provides reliable transport solutions for offices, meetings, and employee travel with punctual and comfortable rides."
  },
  {
    "title": "Family Cab Booking in Pune",
    "description": "Spacious vehicles like Innova, Ertiga, and SUVs are available for family cab booking in Pune, ensuring safe and comfortable group travel."
  },
  {
    "title": "Hourly Cab Rental in Pune",
    "description": "Hourly cab booking allows flexible city travel in Pune for shopping, meetings, or multiple stops with affordable time-based rental options."
  },
  {
    "title": "Luxury Cab Booking Pune",
    "description": "Luxury cab booking in Pune offers premium vehicles for weddings, events, and high-end travel experiences with professional chauffeurs."
  }
],



services: [
  {
    name: "Pune Cab Booking",
    description: "Pune cab booking service provides convenient transportation solutions for local travel, airport transfers, corporate trips, and outstation journeys. Comfortable vehicles with experienced drivers ensure safe and smooth travel for passengers across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Vehicles include sedan cars, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Online Cab Booking Pune",
    description: "Online cab booking Pune service allows passengers to reserve taxis quickly for city travel, airport transfers, and outstation journeys. Well-maintained vehicles provide comfortable seating and smooth travel experience for passengers. Professional drivers ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Flexible booking options allow instant and advance online cab reservations."
  },
  {
    name: "Cab Booking App Pune",
    description: "Cab booking app Pune service offers easy taxi reservation options for passengers looking for convenient city and outstation transportation. Comfortable vehicles ensure reliable travel experience for daily commuters, tourists, and corporate travelers. Professional drivers provide safe driving and timely pickup services across Pune. Pickup services are available from residential areas, offices, hotels, railway stations, and airport terminals. Flexible booking options allow passengers to book cabs instantly through convenient booking methods."
  },
  {
    name: "Instant Cab Booking Pune",
    description: "Instant cab booking Pune service provides quick transportation solutions for passengers requiring immediate travel within Pune and nearby destinations. Vehicles are comfortable and suitable for airport transfers, office travel, and emergency transportation needs. Professional drivers ensure fast pickup and safe driving services across Pune city. Pickup services are available from homes, offices, hotels, railway stations, and airports. Flexible booking options allow hassle-free instant taxi reservations."
  },
  {
    name: "Book Cab Pune",
    description: "Book cab Pune service offers reliable transportation for local travel, business trips, airport transfers, and outstation journeys. Comfortable vehicles provide smooth city and highway travel with experienced drivers ensuring passenger safety. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Vehicles include sedans, SUVs, luxury cars, and tempo travellers suitable for different travel needs. Flexible booking options allow convenient travel planning."
  },
  {
    name: "Pune Cab Reservation",
    description: "Pune cab reservation service allows travelers to schedule taxis in advance for local travel, airport pickups, and outstation trips. Vehicles are well-maintained and suitable for comfortable city and highway journeys. Professional drivers ensure punctual pickup and dependable transportation services throughout the journey. Pickup services are available across Pune including residential areas, hotels, offices, railway stations, and airports. Flexible booking options allow convenient advance cab reservations."
  },
  {
    name: "Taxi Booking Pune Online",
    description: "Taxi booking Pune online service provides convenient cab reservation options for passengers traveling within Pune and nearby destinations. Comfortable vehicles ensure reliable travel for families, tourists, and business travelers. Professional drivers ensure safe driving and punctual pickup services across Pune city and highways. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow easy online taxi reservations."
  },
  {
    name: "Local Cab Booking Pune",
    description: "Local cab booking Pune service offers dependable transportation for daily travel, shopping trips, office commutes, and city sightseeing. Vehicles provide comfortable seating and smooth city travel experience for passengers. Professional drivers ensure safe journeys and timely pickup services throughout Pune city. Pickup services are available from residential areas, hotels, offices, railway stations, and airports. Flexible booking options allow convenient local cab reservations."
  },
  {
    name: "Outstation Cab Booking Pune",
    description: "Outstation cab booking Pune service provides reliable transportation for long-distance journeys from Pune to various tourist destinations and business cities. Vehicles include sedans, SUVs, Innova Crysta, and premium cars suitable for comfortable highway travel. Professional drivers ensure smooth and safe journeys for passengers. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient one-way and round-trip travel reservations."
  },
  {
    name: "Cab Hire Pune",
    description: "Cab hire Pune service offers comfortable rental transportation for local travel, airport transfers, corporate travel, and tourism trips. Vehicles are suitable for individuals, families, and group travelers looking for reliable transportation solutions. Professional chauffeurs ensure safe driving and punctual pickup services throughout Pune and nearby destinations. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient cab hire reservations."
  },
  {
    name: "Best Cab Booking Pune",
    description: "Best cab booking Pune service provides premium transportation experience with comfortable vehicles and professional chauffeurs. Vehicles ensure smooth city and highway travel suitable for airport transfers, business trips, tourism, and family travel. Professional drivers ensure punctual pickup and reliable transportation services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient local and outstation cab reservations."
  },
  {
    name: "Cab Booking Near Me Pune",
    description: "Cab booking near me Pune service offers nearby taxi availability for passengers requiring quick transportation within Pune city. Comfortable vehicles ensure safe and convenient travel for office commutes, airport transfers, and local trips. Professional drivers provide punctual pickup and smooth travel experience throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Pune. Flexible booking options allow fast and convenient cab reservations."
  },
  {
    name: "Affordable Cab Booking Pune",
    description: "Affordable cab booking Pune service provides budget-friendly transportation for passengers looking for economical city and outstation travel. Comfortable vehicles ensure reliable travel experience while maintaining cost-effective pricing. Professional drivers ensure safe journeys and punctual pickup services for passengers across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient and affordable cab reservations."
  },
  {
    name: "Pune Cab Hire Service",
    description: "Pune cab hire service offers dependable transportation for city travel, airport transfers, tourism, and outstation journeys. Vehicles include sedans, SUVs, luxury cars, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow easy cab hire planning."
  },
  {
    name: "Quick Cab Booking Pune",
    description: "Quick cab booking Pune service provides fast and reliable transportation for passengers requiring immediate travel assistance within Pune. Vehicles ensure comfortable city travel and smooth transportation for airport transfers, office trips, and emergency travel needs. Professional drivers ensure quick pickup and safe driving services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports. Flexible booking options allow instant cab reservations."
  },
  {
    name: "Round Trip Cab Booking",
    description: "Round trip cab booking service provides convenient return transportation for passengers planning local and outstation journeys from Pune. Comfortable vehicles ensure smooth travel with experienced drivers offering safe highway and city transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for business travel, tourism trips, family visits, and pilgrimage tours. Flexible booking options allow convenient round-trip cab reservations."
  }
],

tableData: [
  ["Pune Cab Booking", "Online Cab Booking Pune"],
  ["Cab Booking App Pune", "Instant Cab Booking Pune"],
  ["Book Cab Pune", "Pune Cab Reservation"],
  ["Taxi Booking Pune Online", "Local Cab Booking Pune"],
  ["Outstation Cab Booking Pune", "Cab Hire Pune"],
  ["Best Cab Booking Pune", "Cab Booking Near Me Pune"],
  ["Affordable Cab Booking Pune", "Pune Cab Hire Service"],
  ["Quick Cab Booking Pune", "Round Trip Cab Booking"]
],



 whychoose: [
      {
        WhyChooseheading: "Easy Pune Cab Booking Process",
        WhyChoosedescription: "Shivai Travels offers a simple and hassle-free Pune cab booking process for local travel, airport transfers, and outstation trips. Customers can quickly reserve taxis through phone or online booking."
      },
      {
        WhyChooseheading: "Affordable Cab Booking Pricing",
        WhyChoosedescription: "Shivai Travels provides affordable Pune cab booking services with transparent fare details and no hidden charges. Customers receive clear pricing information before confirming their trip."
      },
      {
        WhyChooseheading: "24/7 Cab Booking Availability",
        WhyChoosedescription: "Our Pune cab booking service is available 24 hours a day for airport pickups, late-night travel, emergency transportation, business meetings, and outstation journeys."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Vehicles",
        WhyChoosedescription: "All vehicles provided by Shivai Travels are fully air-conditioned, clean, and regularly maintained to ensure safe and comfortable travel for passengers."
      },
      {
        WhyChooseheading: "Flexible Local & Outstation Travel Options",
        WhyChoosedescription: "Shivai Travels offers flexible Pune cab booking options including local city travel, one-way taxi service, round trips, airport transfers, and customized outstation tours."
      },
      {
        WhyChooseheading: "Multiple Vehicle Choices for Every Need",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for solo travelers, families, corporate employees, and groups."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup services from homes, offices, hotels, Pune Airport, railway stations, and all major areas including Wakad, Baner, Hadapsar, Kharadi, and Hinjewadi."
      },
      {
        WhyChooseheading: "Trusted Pune Cab Booking Service",
        WhyChoosedescription: "Shivai Travels is trusted for reliable Pune cab booking services with punctual drivers, professional customer support, comfortable vehicles, and smooth travel experiences."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune cab booking service?", answer: "Pune cab booking service allows customers to book taxis for local travel, airport transfers, and outstation journeys from Pune." },
    { question: "Is Pune cab booking available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune cab booking service for all travel requirements." },
    { question: "Which vehicles are available for Pune cab booking?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book one-way cabs from Pune?", answer: "Yes, customers can book one-way as well as round-trip taxi services from Pune." },
    { question: "Do you provide Pune Airport cab booking?", answer: "Yes, Shivai Travels provides airport pickup and drop taxi booking services in Pune." },
    { question: "Are all taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for passenger comfort." },
    { question: "Can I book a cab online in Pune?", answer: "Yes, customers can easily book Pune cabs online or through phone booking." },
    { question: "Do you provide cabs for family trips?", answer: "Yes, Shivai Travels provides comfortable cabs for family tours, vacations, and group travel." },
    { question: "Are cab booking charges transparent?", answer: "Yes, Shivai Travels provides transparent and affordable pricing without hidden charges." },
    { question: "Is advance cab booking available?", answer: "Yes, advance cab booking is available and recommended for weekends, holidays, and airport transfers." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Pravin More",
      feedback:
        "Very easy Pune cab booking experience with Shivai Travels. The cab arrived on time and the driver was professional.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Patil",
      feedback:
        "We have Booked a Pune airport cab through Shivai Travels. Affordable fare, clean car, and excellent customer support.",
      rating: 5
    }
  ];











































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Cab Booking",
  "image": "https://shivaitravels.com/assets/images/pune-cab-booking.jpg",
  "description": "Book Pune cab service online for local travel, airport transfers, outstation trips, and corporate travel. Affordable sedan, SUV, and Innova cab booking available with instant confirmation and 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-cab-booking"
  }
};








  return (
    <div>

<Helmet>
  <title>Pune Cab Booking | Online & Affordable Cab Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune cab service online for local and outstation travel. Affordable taxi booking, airport cabs, Pune to Mumbai cab service, and 24x7 cab booking available with instant confirmation."
  />

  <meta
    name="keywords"
    content="pune cab booking, online cab booking pune, cab booking app pune, instant cab booking pune, book cab pune, pune cab reservation, taxi booking pune online, local cab booking pune, outstation cab booking pune, cab hire pune, best cab booking pune, cab booking near me pune, affordable cab booking pune, pune cab hire service, quick cab booking pune, Outstation Cabs Pune, Cheapest cab service in pune, Online cab booking pune, Pune to mumbai cab service, Taxi Services in Pune, Pune Cab Booking, Cab Booking Service Pune, Online Cab Booking Pune, Best Cab Booking in Pune, 24x7 Cab Booking Pune, Pune Taxi Booking Service, Local Cab Booking Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/3.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punecabbooking;